export default "__VITE_ASSET__Xpt_CNjd__"